import { useQuery } from '@tanstack/react-query';
import { InvitationsApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useInvitationsControllerListInvitationsQuery(args, options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useQuery({
        queryKey: ['invitationsControllerListInvitations', accessControlScope, args],
        queryFn: async () => {
            const api = new InvitationsApi(accessControlConfig);
            return api.invitationsControllerListInvitations(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useInvitationsControllerListInvitationsQuery.js.map